// import { useState, useEffect } from "react";
import * as OrderService from "../../../../services/OrderServices";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "../orderList/orderList.styled";
import CloseOrder from "../closeOrder";
import { REPROCESOS } from "../../../../constants";

export const useOrder = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const actionClose = async (uuid, origin) => {
    if (origin && origin === REPROCESOS.code) {
      try {
        const result = await OrderService.closeOrder(uuid, true);
        if (result) {
          if (refresh) {
            refresh();
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      const okAction = async () => {
        try {
          const result = await OrderService.closeOrder(uuid, true);
          if (result) {
            if (refresh) {
              refresh();
            }
          }
        } catch (error) {
          if (error.data.error.code === "BORRELL.NOT_CONNECT") {
            closeOrderWithManualWeight(uuid, true);
          } else {
            console.log(error);
          }
        }
      };

      const cancelAction = async () => {
        try {
          const result = await OrderService.closeOrder(uuid, false);
          if (result) {
            if (refresh) {
              refresh();
            }
          }
        } catch (error) {
          if (error.data.error.code === "BORRELL.NOT_CONNECT") {
            closeOrderWithManualWeight(uuid, false);
          } else {
            console.log(error);
          }
        }
      };

      showDialog(
        t("forms.order.dialog.partial.title"),
        t("forms.order.dialog.partial.text"),
        "question",
        true,
        t("forms.order.dialog.partial.buttonOk"),
        false,
        okAction,
        t("forms.order.dialog.partial.buttonNo"),
        cancelAction
      );
    }
  };

  const closeOrderWithManualWeight = async (uuid, finish) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <CloseOrder
                  siloFinish={finish}
                  orderUuid={uuid}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => refresh()}
                ></CloseOrder>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const closeOrder = async (uuid, origin = null) => {
    try {
      const okAction = async () => {
        await actionClose(uuid, origin);
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.order.dialog.close.title"),
        t("forms.order.dialog.close.text"),
        "question",
        true,
        t("forms.order.dialog.close.buttonOk"),
        false,
        okAction,
        t("forms.order.dialog.close.buttonNo"),
        cancelAction
      );
    } catch (error) {
      console.log(error);
    }
  };

  const resumeOrder = async (uuid) => {
    try {
      const okAction = async () => {
        try {
          const result = await OrderService.resumeOrder(uuid);
          if (result) {
            if (refresh) {
              refresh();
            }
          }
        } catch (error) {}
      };

      const cancelAction = () => {};

      showDialog(
        t("forms.order.dialog.resume.title"),
        t("forms.order.dialog.resume.text"),
        "question",
        true,
        t("forms.order.dialog.resume.buttonOk"),
        false,
        okAction,
        t("forms.order.dialog.resume.buttonNo"),
        cancelAction
      );
    } catch (error) {}
  };

  return {
    closeOrder,
    resumeOrder,
  };
};
